import { LocalObject } from '../../local'
import { slog } from '../../logging'

const lastSuccessfulSyncs = new LocalObject('offline-loader-last-successful-syncs')

export const shouldSync = (model: string, now = Date.now()): boolean => {
  const syncs = lastSuccessfulSyncs.get() as Record<string, number>
  const lastSuccessfulSync = syncs[model]

  if (!lastSuccessfulSync) {
    slog('offline_loader_should_sync', { model, status: 'unsynced' })
    return true
  }

  const lastSuccessfulSyncDate = new Date(lastSuccessfulSync)
  const currentDate = new Date(now)
  const syncNeeded =
    lastSuccessfulSyncDate.getFullYear() !== currentDate.getFullYear() ||
    lastSuccessfulSyncDate.getMonth() !== currentDate.getMonth() ||
    lastSuccessfulSyncDate.getDate() !== currentDate.getDate()

  slog('offline_loader_should_sync', {
    model,
    status: syncNeeded ? 'outdated' : 'synced',
    lastSuccessfulSyncDate: lastSuccessfulSyncDate.toJSON(),
    currentDate: currentDate.toJSON(),
  })

  return syncNeeded
}

export const markSynced = (model: string, now = Date.now()): void => {
  slog('offline_loader_mark_synced', { model, now: new Date(now).toJSON() })
  lastSuccessfulSyncs.set({ [model]: now })
}
